import React from "react";
import FailedPaymentsManagement from "./FailedPaymentsManagement";
import { useFailedPaymentsManagement } from "./useFailedPaymentsManagement";

export const FailedPaymentsContainer: React.FC = () => {
  const {
    payments,
    loading,
    refreshFailedPayments,
    retryPayment,
    markAsResolved,
    processRefund,
    closePayment,
  } = useFailedPaymentsManagement();

  return (
    <FailedPaymentsManagement
      payments={payments}
      loading={loading}
      onRefresh={refreshFailedPayments}
      onRetryPayment={retryPayment}
      onMarkAsResolved={markAsResolved}
      onRefundPayment={processRefund}
      onClosePayment={closePayment}
    />
  );
};
